import * as React from 'react';
import { Bar, HorizontalBar } from 'react-chartjs-2';
import Chartify from  '@shipsy/chartify';

class BarViz extends React.PureComponent<any, any> {
  omitFalsyValues = (tooltipItem, data) => {              
    if (!tooltipItem.yLabel) {
      return false;
    }
    return true;
  }

  render() {
    const { formData, chartData } = this.props;
    const chartifyInstance = new Chartify.BarData(chartData, formData);
    const chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();
    return (formData.bar_type === 'horizontal') ? (
      <HorizontalBar data={chartifyData.data.barChartData}
        options={chartifyData.options}></HorizontalBar>
    ) : (<Bar
      data={chartifyData.data.barChartData}
        options={{
          ...(chartifyData.options || {}),
          tooltips: {
            ...((chartifyData.options as any)?.tooltips || {}),
            filter: this.omitFalsyValues,
          }
        }}
    />);
  }
}

export default BarViz;
